"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadMoreBtn;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _button = _interopRequireWildcard(require("@kyruus/button"));
var _intl = require("@kyruus/intl");
var _States = require("../../../lib/constants/States");
var _styles = require("./styles");
var _utils = require("../../../lib/utils");
var _configUtils = require("../../../lib/configUtils");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _PhoneNumberLink = _interopRequireDefault(require("../../PhoneNumberLink/PhoneNumberLink"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function LoadMoreBtn(_ref) {
  let {
    currentState,
    onClick,
    config
  } = _ref;
  const {
    appointments,
    provider,
    lastApptQueriedFor
  } = currentState.context;

  /**
   * Setting phone to empty string here will take care of displaying an alternate banner without a phone number.
   */
  const phone = (0, _configUtils.shouldHideSchedulingHelpMessages)(config) ? '' : (0, _utils.getMainContactNumber)(provider);
  const formattedLastApptQueriedFor = (0, _utils.formatLastApptShownDate)(lastApptQueriedFor);
  if (currentState.matches(`${_States.nextSearch}.${_States.noResults}`)) {
    return /*#__PURE__*/_react.default.createElement(_styles.LoadMoreBtnContainer, {
      "data-testid": "LoadMoreBtn__noresults"
    }, /*#__PURE__*/_react.default.createElement(_styles.NoMoreApptsMsg, null, phone ? /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.noFutureAppointmentsWithPhone, {
      values: {
        phone_number_link: /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
          phone: phone
        })
      }
    })) : /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.noFutureAppointments)));
  }
  if (currentState.matches(`${_States.nextSearch}.${_States.pending}`)) {
    return /*#__PURE__*/_react.default.createElement(_styles.LoadMoreBtnContainer, {
      "data-testid": "LoadMoreBtn__pending"
    }, /*#__PURE__*/_react.default.createElement(_button.ButtonWithSpinner, {
      mode: "primary",
      showSpinner: true,
      disabled: true
    }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.loadMoreBtnText)));
  }
  return appointments[0] && /*#__PURE__*/_react.default.createElement(_styles.LoadMoreBtnContainer, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-testid": "LoadMoreBtn",
    mode: "primary",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.loadMoreBtnText)), /*#__PURE__*/_react.default.createElement(_styles.ApptsUpToDateMsg, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.showingAppointmentsUpToDate, {
    values: {
      date_queried_to: formattedLastApptQueriedFor
    }
  }))));
}
LoadMoreBtn.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LoadMoreBtn"
};